import React from 'react';
import { Search, Rocket, TrendingUp, Users } from 'lucide-react';
import { APPROACH } from '../mock';

const iconMap = { Search, Rocket, TrendingUp, Users };

const Approach = () => {
  return (
    <section id="approach" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
            How we work
          </div>
          <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
            Small steps.{' '}
            <span className="text-indigo-600">Compounding wins.</span>
          </h2>
          <p className="mt-5 text-[16.5px] leading-relaxed text-slate-600 max-w-2xl">
            A four-phase engagement model designed to prove value fast, ship into production, and hand ownership back to your team.
          </p>
        </div>

        <div className="mt-14 relative">
          {/* Connector line (desktop) */}
          <div
            aria-hidden
            className="hidden lg:block absolute top-[46px] left-8 right-8 h-px bg-gradient-to-r from-transparent via-indigo-200 to-transparent"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {APPROACH.map((p) => {
              const Icon = iconMap[p.icon] || Search;
              return (
                <div
                  key={p.id}
                  className="group relative rounded-2xl border border-slate-200 bg-white p-6 hover:border-indigo-200 hover:shadow-xl hover:shadow-indigo-500/5 transition-all duration-300"
                >
                  <div className="flex items-center justify-between">
                    <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-50 to-violet-50 flex items-center justify-center ring-1 ring-slate-200/70">
                      <Icon size={22} className="text-indigo-600" strokeWidth={2} />
                    </div>
                    <span className="font-display text-[34px] font-semibold text-slate-200 tracking-tight">
                      {p.step}
                    </span>
                  </div>
                  <h3 className="mt-5 font-display text-[20px] font-semibold text-slate-900 tracking-tight">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-slate-600">
                    {p.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
